import { Component, OnInit, AfterViewChecked, ChangeDetectorRef, HostListener } from '@angular/core';
import { HttpLoader } from '../shared/services/httploader.service';

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html'
})
export class MainComponent implements OnInit, AfterViewChecked {
  isNavbarVisible = true;
  isMobileDevice = false;
  loader$;

  constructor(
    private loader: HttpLoader,
    private detector: ChangeDetectorRef
  ) { }

  ngOnInit() {
    window.dispatchEvent(new Event('resize'));
  }

  ngAfterViewChecked() {
    this.loader$ = this.loader.loader$;
    this.detector.detectChanges();
  }

  onMobileHideNavbar() {
    if (this.isMobileDevice && this.isNavbarVisible) {
        this.isNavbarVisible = false;
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    // TODO: Find better way to detect mobile version.
    this.isMobileDevice = (event.target.innerWidth <= 480);
    if (this.isMobileDevice) {
      this.isNavbarVisible = false;
    }
  }
}
